module.exports = __webpack_public_path__ + "img/result-product-3.381259f1.png";